import axios from "axios";

export const read = async (thisClient) => {
    
        try{
            return axios.get(`${process.env.REACT_APP_BACKEND_URL}/KlienProfile?thisClient=${thisClient}`,{
            })
        } catch(error){
            throw new Error(error);
        }
   

}